import '../../../style/expanded.scss'

export default {
  name: 'ExpandIcon',
  functional: true,
  render(h, context) {
    const { iconStyle, expanded, onExpand, loading, treeTableIcon } = context.props
    const expandIcon = [
      'table_v2__expand-icon',
      expanded ? 'is-expanded' : ''
    ]
    return (
      <div
        onClick={() => !loading && onExpand(!expanded)}
        class={expandIcon}
        style={iconStyle}>
        {
          (treeTableIcon && !loading) ? treeTableIcon(h, context) : <i class={ loading ? 'el-icon-loading' : 'el-icon-arrow-right'}></i>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/feature/expanded/index.js